import {
  CUSTOM_TEMPLATES_ADD_INPUT,
  CUSTOM_TEMPLATES_ADD_SECTION,
  CUSTOM_TEMPLATES_DELETE_INPUT,
  CUSTOM_TEMPLATES_DELETE_OPTION,
  CUSTOM_TEMPLATES_DELETE_OPTIONS,
  CUSTOM_TEMPLATES_DELETE_SECTION,
  CUSTOM_TEMPLATES_DELETE_TEMPLATE,
  CUSTOM_TEMPLATES_GET_CREATE_UPDATE_OPTIONS,
  CUSTOM_TEMPLATES_GET_OPTIONS,
  CUSTOM_TEMPLATES_GET_TEMPLATE_DETAILS,
  CUSTOM_TEMPLATES_UPDATE_INPUT,
  CUSTOM_TEMPLATES_UPDATE_SECTION,
  CUSTOM_TEMPLATES_UPDATE_TEMPLATE_DETAILS,
  GET_TEMPLATE_DETAILS,
  BILLING_ADD_UPDATE_BILLING_OPTION,
  BILLING_ADD_UPDATE_FIELD_VALUE,
  BILLING_ADD_UPDATE_HEADER,
  BILLING_ADD_UPDATE_ROW,
  BILLING_DELETE_COLUMN,
  BILLING_DELETE_COLUMN_OPTION,
  BILLING_DELETE_FIELD_OPTION,
  BILLING_DELETE_ROW,
  BILLING_GET_COLUMN_DROPDOWN_OPTIONS,
  BILLING_GET_HEADER,
  BILLING_GET_HEADER_VALUES,
  MANAGE_PERMISSION_ADD_GROUP_PERMISSION_MEMBER,
  MANAGE_PERMISSION_DELETE_GROUP_PERMISSION_MEMBER,
  MANAGE_PERMISSIONS_ADD_UPDATE_GROUP,
  MANAGE_PERMISSIONS_ADD_UPDATE_GROUP_PERMISSION,
  MANAGE_PERMISSIONS_ADD_UPDATE_PERMISSION,
  MANAGE_PERMISSIONS_DELETE_GROUP,
  MANAGE_PERMISSIONS_DELETE_GROUP_MEMBER,
  MANAGE_PERMISSIONS_DELETE_PERMISSION,
  MANAGE_PERMISSIONS_FETCH_DATA,
  MANAGE_PERMISSIONS_GRANT_PERMISSION,
  MY_SPACE_ADD_LIST,
  MY_SPACE_ADD_TABLE_COLUMN,
  MY_SPACE_ADD_TABLE_COLUMN_OPTIONS,
  MY_SPACE_ADD_TABLE_FIELD,
  MY_SPACE_ADD_UPDATE_TABLE_CELL,
  MY_SPACE_BULK_DELETE_COLUMN,
  MY_SPACE_BULK_UPDATE_LIST,
  MY_SPACE_CSV_UPLOAD,
  MY_SPACE_DELETE_FILE_FOLDER,
  MY_SPACE_DELETE_OPTION,
  MY_SPACE_DELETE_ROW_LIST_DATA,
  MY_SPACE_FIELD_OPTIONS,
  MY_SPACE_GET_FOLDER,
  MY_SPACE_GET_PINNED_LIST,
  MY_SPACE_GET_TABLE_BODY,
  MY_SPACE_GET_TABLE_HEADERS,
  MY_SPACE_GET_USER_ACCESS,
  MY_SPACE_MARKED_AS_PINNED,
  MY_SPACE_MARKED_AS_UNPINNED,
  MY_SPACE_PERSON_LIST,
  MY_SPACE_REMOVE_USER_ACCESS,
  MY_SPACE_RENAME_AND_MOVE_FOLDER_FILE,
  MY_SPACE_ROW_EDIT,
  MY_SPACE_SEND_ACCESS,
  MY_SPACE_SHARED_FILE_FOLDER,
  MY_SPACE_UPDATE_TABLE_COLUMN_NAME,
  MY_SPACE_UPDATE_USER_ACCESS,
  MY_SPACE_UPLOAD_FILE,
  CUSTOM_CREATE_TEMPLATE,
  CUSTOM_TEMPLATES_DEPLOY_TEMPLATE,
  CUSTOM_MODULE_GET_HEADER,
  CUSTOM_MODULE_GET_HEADER_VALUES,
  CUSTOM_MODULE_ADD_UPDATE_HEADER,
  CUSTOM_MODULE_ADD_UPDATE_FIELD_VALUE,
  CUSTOM_MODULE_GET_COLUMN_DROPDOWN_OPTIONS,
  CUSTOM_MODULE_DELETE_FIELD_OPTION,
  CUSTOM_MODULE_DELETE_COLUMN,
  CUSTOM_MODULE_DELETE_ROW,
  CUSTOM_MODULE_ADD_UPDATE_ROW,
  CUSTOM_MODULE_DELETE_COLUMN_OPTION,
  CUSTOM_MODULE_ADD_UPDATE_CUSTOM_MODULE_OPTION,
  CUSTOM_TEMPLATES_DELETE,
} from "./constants";

const MANAGE_PERMISSIONS = {
  FETCH_DATA: {
    method: "GET",
    url: () => MANAGE_PERMISSIONS_FETCH_DATA,
    queryParams: ["key", "permission_id", "company_id"],
    description: "Fetches the list of permissions for a specific company.",
  },
  ADD_UPDATE_PERMISSION: {
    method: "POST",
    url: () => MANAGE_PERMISSIONS_ADD_UPDATE_PERMISSION,
    bodyParams: ["permission_name", "permission_description", "company_id", "modules"],
    description: "Adds or updates a group for a specific company.",
  },
  ADD_UPDATE_GROUP: {
    method: "POST",
    url: () => MANAGE_PERMISSIONS_ADD_UPDATE_GROUP,
    bodyParams: ["company_id", "group_name", "description", "permission_level_id", "group_owner"],
    description: "Adds or updates a group for a specific company.",
  },
  GRANT_PERMISSION: {
    method: "POST",
    url: () => MANAGE_PERMISSIONS_GRANT_PERMISSION,
    // bodyParams: ["company_id", "group_name", "description", "permission_level_id", "group_owner"],
    description: "Adds or updates a group for a specific company.",
  },
  DELETE_GROUP: {
    method: "POST",
    url: () => MANAGE_PERMISSIONS_DELETE_GROUP,
    // bodyParams: ["company_id", "group_name", "description", "permission_level_id", "group_owner"],
    description: "Adds or updates a group for a specific company.",
  },
  DELETE_PERMISSION: {
    method: "POST",
    url: () => MANAGE_PERMISSIONS_DELETE_PERMISSION,
    // bodyParams: ["company_id", "group_name", "description", "permission_level_id", "group_owner"],
    description: "Adds or updates a group for a specific company.",
  },
  DELETE_GROUP_PERMISSION: {
    method: "POST",
    url: () => MANAGE_PERMISSIONS_DELETE_GROUP_MEMBER,
    bodyParams: ["group_id", "company_id", "group_member_id"],
    description: "Adds or updates a group for a specific company.",
  },

  GET_GROUP_PERMISSION: {
    method: "GET",
    url: () => MANAGE_PERMISSIONS_FETCH_DATA,
    queryParams: ["key", "group_id"],
    description: "Fetches the list of permissions for a specific company.",
  },

  ADD_GROUP_PERMISSION_MEMBER: {
    method: "POST",
    url: () => MANAGE_PERMISSION_ADD_GROUP_PERMISSION_MEMBER,
    body: ["group_member_ids", "group_ids"],
    description: "Add members to a group.",
  },
  DELETE_GROUP_PERMISSION_MEMBER: {
    method: "POST",
    url: () => MANAGE_PERMISSION_DELETE_GROUP_PERMISSION_MEMBER,
    body: ["group_member_id", "group_id"],
    description: "Delete members from a group.",
  },
  ADD_UPDATE_GROUP_PERMISSION: {
    method: "POST",
    url: () => MANAGE_PERMISSIONS_ADD_UPDATE_GROUP_PERMISSION,
    body: ["group_member_id", "group_id"],
    description: "Add update member to a group.",
  },
};

const MYSPACE = {
  FETCH_FOLDER_DATA: {
    method: "GET",
    url: () => MY_SPACE_GET_FOLDER,
    // queryParams: ["folderId"],
    description: "Get all data for a specific folder.",
  },
  CREATE_FOLDER_DATA: {
    method: "POST",
    url: () => MY_SPACE_GET_FOLDER,
    body: ["name", "parent_id"],
    description: "Create a new folder.",
  },
  UPLOAD_FILE: {
    method: "POST",
    url: () => MY_SPACE_UPLOAD_FILE,
    body: ["file"],
    queryParams: ["parent_id"],
    description: "Create a new file.",
  },
  RENAME_AND_MOVE_FOLDER_FILE: {
    method: "PUT",
    url: () => MY_SPACE_RENAME_AND_MOVE_FOLDER_FILE,
    body: ["name", "parent_id"],
    params: ["folder-file-id"],
    description: "Rename file and move folder.",
  },
  GET_TABLE_HEADERS: {
    method: "GET",
    url: () => MY_SPACE_GET_TABLE_HEADERS,
    params: ["tableId"],
    description: "Get all table headers for a specific table.",
  },
  GET_TABLE_BODY: {
    method: "GET",
    url: () => MY_SPACE_GET_TABLE_BODY,
    params: ["tableId"],
    description: "Get all table body for a specific table.",
  },
  ADD_TABLE_COLUMN: {
    method: "POST",
    url: () => MY_SPACE_ADD_TABLE_COLUMN,
    body: ["field_label", "field_type"],
    params: ["tableId"],
    description: "Add column in specific table.",
  },
  ADD_UPDATE_TABLE_CELL: {
    method: "POST",
    url: () => MY_SPACE_ADD_UPDATE_TABLE_CELL,
    body: ["field_id", "value"],
    params: ["tableId"],
    description: "Add update table cell in specific table.",
  },
  ADD_LIST: {
    method: "POST",
    url: () => MY_SPACE_ADD_LIST,
    body: ["field_label", "field_type"],
    description: "Add table field for a specific table.",
  },
  ADD_TABLE_COLUMN_OPTIONS: {
    method: "POST",
    url: () => MY_SPACE_ADD_TABLE_COLUMN_OPTIONS,
    body: ["options"],
    params: ["tableColumnId"],
    description: "Add options for column type dropdown.",
  },
  CSV_UPLOAD: {
    method: "POST",
    url: () => MY_SPACE_CSV_UPLOAD,
    body: ["file", "fields"],
    // queryParams: ["parentId"],
    description: "Upload CSV file in formData.",
  },
  DELETE_FILE_FOLDER: {
    method: "DELETE",
    url: () => MY_SPACE_DELETE_FILE_FOLDER,
    queryParams: ["folder-file-id"],
    description: "File folder deletion.",
  },
  FIELD_OPTIONS: {
    method: "GET",
    url: () => MY_SPACE_FIELD_OPTIONS,
    params: ["fieldId"],
    description: "Get all field options for a specific field.",
  },
  ADD_UPDATE_FIELD_OPTIONS: {
    method: "POST",
    url: () => MY_SPACE_FIELD_OPTIONS,
    params: ["fieldId"],
    body: ["optionId", "option"],
    description: "Add and update option for a specific column.",
  },
  UPDATE_TABLE_COLUMN_NAME: {
    method: "PUT",
    url: () => MY_SPACE_UPDATE_TABLE_COLUMN_NAME,
    body: ["field_label"],
    params: ["tableId", "tableId"],
    description: "Update table column.",
  },
  DELETE_ROW_LIST_DATA: {
    method: "POST",
    url: () => MY_SPACE_DELETE_ROW_LIST_DATA,
    body: ["rowIds"],
    params: ["tableId"],
    description: "Delete table row.",
  },
  BULK_UPDATE_LIST: {
    method: "PUT",
    url: () => MY_SPACE_BULK_UPDATE_LIST,
    body: ["rowIds", "fieldId", "data"],
    params: ["tableId"],
    description: "bulk update table row.",
  },
  BULK_DELETE_COLUMN: {
    method: "POST",
    url: () => MY_SPACE_BULK_DELETE_COLUMN,
    body: ["fieldIds"],
    params: ["tableId"],
    description: "bulk delete table column.",
  },
  ROW_EDIT: {
    method: "POST",
    url: () => MY_SPACE_ROW_EDIT,
    body: ["fieldIds"],
    params: ["tableId"],
    description: "bulk delete table column.",
  },
  SEND_ACCESS: {
    method: "POST",
    url: () => MY_SPACE_SEND_ACCESS,
    body: ["containerId", "userIds", "access"],
    params: ["tableId"],
    description: "Add access in bulk for assets.",
  },
  GET_USER_ACCESS: {
    method: "GET",
    url: () => MY_SPACE_GET_USER_ACCESS,
    params: ["containerId"],
    description: "Get list of users with access of the particular asset.",
  },
  UPDATE_USER_ACCESS: {
    method: "PUT",
    url: () => MY_SPACE_UPDATE_USER_ACCESS,
    params: ["containerId"],
    body: ["userId", "access"],
    description: "Get list of users with access of the particular asset.",
  },
  REMOVE_USER_ACCESS: {
    method: "POST",
    url: () => MY_SPACE_REMOVE_USER_ACCESS,
    params: ["containerId"],
    body: ["userId"],
    description: "Get list of users with access of the particular asset.",
  },
  SHARED_FILE_FOLDER: {
    method: "GET",
    url: () => MY_SPACE_SHARED_FILE_FOLDER,
    description: "Get list of shared file folders.",
  },
  PERSON_LIST: {
    method: "GET",
    url: () => MY_SPACE_PERSON_LIST,
    params: ["compantId"],
    description: "Get all person list.",
  },
  DELETE_OPTION: {
    method: "DELETE",
    url: () => MY_SPACE_DELETE_OPTION,
    params: ["fieldId", "optionId"],
    description: "Delete single option.",
  },
  GET_PINNED_LIST: {
    method: "GET",
    url: () => MY_SPACE_GET_PINNED_LIST,
    params: ["fieldId", "optionId"],
    description: "Get all pinned list.",
  },
  MARKED_AS_PINNED: {
    method: "POST",
    url: () => MY_SPACE_MARKED_AS_PINNED,
    body: ["containerId"],
    description: "Mark as pinned for a specific container.",
  },
  MARKED_AS_UNPINNED: {
    method: "POST",
    url: () => MY_SPACE_MARKED_AS_UNPINNED,
    body: ["containerId"],
    description: "Mark as unpinned for a specific container.",
  },
};

const CUSTOM_TEMPLATES = {
  CREATE_TEMPLATE: {
    method: "POST",
    url: () => CUSTOM_CREATE_TEMPLATE,
    body: ["template_name", "meta", "is_active", "is_notes", "is_documents", "is_tasks", "is_multi_records"],
    description: "Create new template",
  },
  DEPLOY_TEMPLATE: {
    method: "POST",
    url: () => CUSTOM_TEMPLATES_DEPLOY_TEMPLATE,
    body: ["id", "scope", "is_deployed"],
    description: "Deploy template",
  },
  GET_TEMPLATE_DETAILS: {
    method: "GET",
    url: () => CUSTOM_TEMPLATES_GET_TEMPLATE_DETAILS,
    params: ["template_id"],
    description: "Get template details with sections and inputs",
  },
  UPDATE_TEMPLATE_DETAILS: {
    method: "POST",
    url: () => CUSTOM_TEMPLATES_UPDATE_TEMPLATE_DETAILS,
    body: ["id", "template_name", "meta", "is_active", "is_notes", "is_documents", "is_tasks"],
    description: "Update template details",
  },
  ADD_SECTION: {
    method: "POST",
    url: () => CUSTOM_TEMPLATES_ADD_SECTION,
    body: ["section_name", "template_id", "meta"],
    description: "Add new section in template",
  },
  UPDATE_SECTION: {
    method: "POST",
    url: () => CUSTOM_TEMPLATES_UPDATE_SECTION,
    body: ["section_name", "id", "template_id", "meta"],
    description: "Add new section in template",
  },
  ADD_INPUT: {
    method: "POST",
    url: () => CUSTOM_TEMPLATES_ADD_INPUT,
    body: ["field_label", "field_type", "description", "section_id", "dropdown_options"],
    description: "Add new input in section",
  },
  UPDATE_INPUT: {
    method: "POST",
    url: () => CUSTOM_TEMPLATES_UPDATE_INPUT,
    body: ["field_label", "field_type", "description", "section_id", "dropdown_options"],
    description: "Update input in section",
  },
  DELETE_TEMPLATE: {
    method: "DELETE",
    url: () => CUSTOM_TEMPLATES_DELETE_TEMPLATE,
    params: ["template_id"],
    description: "Delete template",
  },
  DELETE_SECTION: {
    method: "DELETE",
    url: () => CUSTOM_TEMPLATES_DELETE_SECTION,
    params: ["section_id"],
    description: "Delete section",
  },
  DELETE_INPUT: {
    method: "DELETE",
    url: () => CUSTOM_TEMPLATES_DELETE_INPUT,
    params: ["field_id"],
    description: "Delete field",
  },
  // GET_CREATE_UPDATE_OPTIONS: {
  //   method: "GET",
  //   url: () => CUSTOM_TEMPLATES_GET_CREATE_UPDATE_OPTIONS,
  //   query: ["field_name"],
  //   params: ["id", "value", "color"],
  //   description: "Get all field options for a specific field.",
  // },
  CREATE_OPTION: {
    method: "POST",
    url: () => CUSTOM_TEMPLATES_GET_CREATE_UPDATE_OPTIONS,
    query: ["field_name"],
    body: ["id", "value", "color"],
    description: "Create new field option.",
  },
  UPDATE_OPTION: {
    method: "POST",
    url: () => CUSTOM_TEMPLATES_GET_CREATE_UPDATE_OPTIONS,
    query: ["field_name"],
    body: ["id", "value", "color"],
    description: "Update field option.",
  },
  GET_OPTIONS: {
    method: "GET",
    url: () => CUSTOM_TEMPLATES_GET_CREATE_UPDATE_OPTIONS,
    query: ["field_name"],
    description: "Get all field options for a specific field.",
  },
  DELETE_OPTION: {
    method: "DELETE",
    url: () => CUSTOM_TEMPLATES_DELETE_OPTION,
    params: ["id"],
    description: "Delete field option.",
  },
};

const BILLINGS = {
  GET_HEADER: {
    method: "GET",
    url: () => BILLING_GET_HEADER,
    description: "Get billing header data.",
  },
  GET_HEADER_VALUE: {
    method: "GET",
    url: () => BILLING_GET_HEADER_VALUES,
    queryParams: ["key"],
    description: "Get billing header value.",
  },
  ADD_UPDATE_HEADER: {
    method: "POST",
    url: () => BILLING_ADD_UPDATE_HEADER,
    body: ["field_label", "description", "field_type", "dropdown_options", "id"],
    description: "Add or update billing header.",
  },
  ADD_UPDATE_FIELD_VALUE: {
    method: "POST",
    url: () => BILLING_ADD_UPDATE_FIELD_VALUE,
    body: ["key"],
    description: "Add or update billing field.",
  },
  GET_COLUMN_DROPDOWN_OPTIONS: {
    method: "GET",
    url: () => BILLING_GET_COLUMN_DROPDOWN_OPTIONS,
    queryParams: ["field_name"],
    description: "Get dropdown options for a specific billing column.",
  },
  ADD_UPDATE_BILLING_OPTION: {
    method: "POST",
    url: () => BILLING_ADD_UPDATE_BILLING_OPTION,
    body: ["value", "color", "id"],
    queryParams: ["field_name"],
    description: "Add or update billing option.",
  },
  DELETE_COLUMN_OPTION: {
    method: "DELETE",
    url: () => BILLING_DELETE_COLUMN_OPTION,
    params: ["optionId"],
    description: "Delete a specific billing column option.",
  },
  DELETE_FIELD_OPTION: {
    method: "DELETE",
    url: () => BILLING_DELETE_FIELD_OPTION,
    params: ["optionId"],
    description: "Delete a specific billing field option.",
  },
  DELETE_COLUMN: {
    method: "DELETE",
    url: () => BILLING_DELETE_COLUMN,
    params: ["fieldId"],
    description: "Delete a specific billing column.",
  },
  DELETE_ROW: {
    method: "DELETE",
    url: () => BILLING_DELETE_ROW,
    params: ["rowId"],
    description: "Delete a specific billing row.",
  },
  ADD_UPDATE_ROW: {
    method: "POST",
    url: () => BILLING_ADD_UPDATE_ROW,
    // body: ["field_label", "description", "field_type", "dropdown_options"],
    description: "Add a new billing row.",
  },
};

const CUSTOM_MODULE = {
  GET_HEADER: {
    method: "GET",
    url: () => CUSTOM_MODULE_GET_HEADER,
    query: ["template_id", "is_company_level"],
    description: "Get billing header data.",
  },
  GET_HEADER_VALUE: {
    method: "GET",
    url: () => CUSTOM_MODULE_GET_HEADER_VALUES,
    query: ["template_id", "core_id", "row_id"],
    description: "Get billing header value.",
  },
  ADD_UPDATE_HEADER: {
    method: "POST",
    url: () => CUSTOM_MODULE_ADD_UPDATE_HEADER,
    body: ["field_label", "description", "field_type", "dropdown_options", "id"],
    description: "Add or update billing header.",
  },
  ADD_UPDATE_FIELD_VALUE: {
    method: "POST",
    url: () => CUSTOM_MODULE_ADD_UPDATE_FIELD_VALUE,
    query: ["template_id", "key"],
    description: "Add or update billing field.",
  },
  GET_COLUMN_DROPDOWN_OPTIONS: {
    method: "GET",
    url: () => CUSTOM_MODULE_GET_COLUMN_DROPDOWN_OPTIONS,
    queryParams: ["field_name"],
    description: "Get dropdown options for a specific billing column.",
  },
  ADD_UPDATE_CUSTOM_MODULE_OPTION: {
    method: "POST",
    url: () => CUSTOM_MODULE_ADD_UPDATE_CUSTOM_MODULE_OPTION,
    body: ["value", "color", "id"],
    queryParams: ["field_name"],
    description: "Add or update billing option.",
  },
  DELETE_COLUMN_OPTION: {
    method: "DELETE",
    url: () => CUSTOM_MODULE_DELETE_COLUMN_OPTION,
    params: ["optionId"],
    description: "Delete a specific billing column option.",
  },
  DELETE_FIELD_OPTION: {
    method: "DELETE",
    url: () => CUSTOM_MODULE_DELETE_FIELD_OPTION,
    params: ["optionId"],
    description: "Delete a specific billing field option.",
  },
  DELETE_COLUMN: {
    method: "DELETE",
    url: () => CUSTOM_MODULE_DELETE_COLUMN,
    params: ["fieldId"],
    description: "Delete a specific billing column.",
  },
  DELETE_ROW: {
    method: "DELETE",
    url: () => CUSTOM_MODULE_DELETE_ROW,
    params: ["rowId"],
    query: ["template_id", "key"],
    description: "Delete a specific billing row.",
  },
  ADD_UPDATE_ROW: {
    method: "POST",
    url: () => CUSTOM_MODULE_ADD_UPDATE_ROW,
    query: ["template_id", "key"],
    description: "Add a new billing row.",
  },
};

export { MANAGE_PERMISSIONS, MYSPACE, CUSTOM_TEMPLATES, BILLINGS, CUSTOM_MODULE };
